import { createReducer, on } from '@ngrx/store';
import { ChemicalElement } from '@app/store/shared/models';
import { ROWS_PER_PAGE } from '@shared/components';
import { elementsActions } from '../actions/elements.actions';
import { GetElementsValue } from '../models';

export interface ElementsState {
    loaded: boolean | null;
    loading: boolean;
    elements: ChemicalElement[];
    value: GetElementsValue;
    total: number;
    lookupLoaded: boolean | null;
    lookup: ChemicalElement[];
}

export const initialState: ElementsState = {
    loaded: null,
    loading: false,
    elements: [],
    value: { page: 1, limit: ROWS_PER_PAGE[0] },
    total: 0,
    lookupLoaded: null,
    lookup: [],
};

export const elementsReducer = createReducer(
    initialState,
    on(elementsActions.getElements, (state, { value }): ElementsState => ({ ...state, value, loading: true })),
    on(elementsActions.getElementsSuccess, (state, { payload }): ElementsState => ({
        ...state,
        loading: false,
        loaded: true,
        elements: payload.items,
        total: payload.total,
    })),
    on(elementsActions.getElementsError, (state): ElementsState => ({ ...state, loading: false, loaded: false })),
    on(elementsActions.getElementsLookup, (state): ElementsState => ({ ...state, lookupLoaded: state.lookupLoaded || null })),
    on(elementsActions.getElementsLookupSuccess, (state, { payload }): ElementsState => ({ ...state, lookupLoaded: true, lookup: payload })),
    on(elementsActions.getElementsLookupError, (state): ElementsState => ({ ...state, lookupLoaded: false })),
    on(elementsActions.clear, (): ElementsState => ({ ...initialState })),
);
